<script setup>
import { computed, ref, watch } from "vue";

import Modal from "@/components/Modal";

const props = defineProps(["category", "buttonStyle"]);
const emit = defineEmits(["addSubcategory"]);

const input = ref(null);

const modalOpen = ref(false);

watch(input, (value) => {
  if (input.value) {
    input.value.focus();
  }
});

function toggleModal() {
  modalOpen.value = !modalOpen.value;
}

function addSubcategory(catName) {
  if (!catName) return;
  emit("addSubcategory", catName);
  toggleModal();
}
</script>

<template>
  <div class="link-add" @click="modalOpen = true"><span>+</span> Add Subcategory</div>
  <Modal :active="modalOpen" @toggle="toggleModal">
    <div class="category-add">
      <input type="text" placeholder="Subcategory Name" ref="input" @keyup.enter="addSubcategory(input.value)" />
      <button @click="addSubcategory(input.value)">Add Subcategory</button>
    </div>
  </Modal>
</template>

<style scoped lang="scss">
@import '../../../scss/partials/variables';

.category-add {
  display: flex;
}

.link-add {
  display: flex;
  gap: 10px;

  span {
    height: 20px;
    width: 20px;
    text-align: center;
  }
}

input {
  margin: 0;
}

button {
  white-space: nowrap;
}

@media screen and (max-width: $breakpoint-xs ) {
  .link-add {
    margin-bottom: 10px;
  }
}
</style>
